module.exports = __webpack_public_path__ + "static/img/contect_1.a384460e.jpg";